module.exports = __webpack_public_path__ + "static/media/RD_Team_image_1_blue.b29fd5f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RD_Team_image_1_blue.jpg
// module id = 121
// module chunks = 0